import { SelectOption } from "../../../helper/reactSelect/types";

const filterOptions = (options: SelectOption[], totalItems: number): SelectOption[] => {
  return options.filter((_, i, arr) => {
    if (i === 0) {
      return true;
    } else {
      return parseInt(arr[i].label, 10) <= totalItems || parseInt(arr[i - 1].label) < totalItems;
    }
  });
};

export default filterOptions;
